import { useEffect, useState } from 'react';

export function useParentSize(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current || !ref.current.parentElement) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize({ width, height });
    });

    observer.observe(ref.current.parentElement);

    return () => observer.disconnect();
  }, [ref]);

  return size;
}
